import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-zoom-image',
  templateUrl: './zoom-image.component.html',
  styleUrl: './zoom-image.component.scss'
})
export class ZoomImageComponent {

url: any;
imageBlob:any;
 constructor(
  private http: HttpClient,
  private dialogRef: MatDialogRef<ZoomImageComponent>,
  private apiService: ApiService,
  @Inject(MAT_DIALOG_DATA) public urlImg: {data: string}){
  this.url = urlImg;

 }

 downloadImagem(): void {

  fetch(this.url,  {method: 'GET', headers: { 'Cache-Control': 'no-cache' }})
  .then(response => {
    if (!response.ok) {
      throw new Error('Erro na requisição.');
    }
    return response.blob();
  })
  .then(blob => {
    const downloadLink = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    downloadLink.href = url;


    const ultimaBarraIndex = this.url.lastIndexOf('/');
    downloadLink.download = this.url.substring(ultimaBarraIndex + 1);

    downloadLink.click();

    window.URL.revokeObjectURL(url);
  })
  .catch(error => console.error('Erro ao baixar a imagem:', error));

}

 close(){
  this.dialogRef.close();
 }
}
